// ITR Filing Services Section Data
export const ITR_FILING_SERVICES_DATA = {
  heading: 'Looking for ITR filing Services?',
  description:
    "India's best tax experts at your service for a tailored, accurate and premium tax filing experience.",
  ctaText: 'See all services',
  ctaLink: 'https://cleartax.in/s/pricing?utm_ref=itr_2025_organic_CT_homepage',
  services: [
    {
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1605873415_taxreturnfilled.svg',
      title: 'ITR Filing Assistance',
      description:
        'Get Expert assistance in tax filing for Salaried and self-employed individuals, NRIs, Capital gains, and more.',
    },
    {
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1651557178_group17737.svg',
      title: 'TDS on Sale of Property',
      description: 'Hassle-free 26QB compliance on sale of property',
    },
    {
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1651557311_group17732.svg',
      title: 'Legal Services',
      description:
        'For drafting and review of legal documents such as Sale deed, Vendor agreement, Co-founders agreement etc',
    },
  ],
};
